import LotteryNumlotDetailContainer from "../../components/lottery/containers/LotteryNumlotDetailContainer";
import LotteryNumlotDetailTemplate from "../../components/lottery/templates/LotteryNumlotDetailTemplate";
import LotteryLocalNav from "../../components/lottery/LotteryLocalNav";

function Qoochan() {
  return (
    <>
      <LotteryLocalNav placement="mainHeader" lotteryKey="qcc" />
      <section className="min-h-screen">
        <LotteryNumlotDetailContainer lotteryKey="qcc" Template={LotteryNumlotDetailTemplate} />
      </section>
      <LotteryLocalNav placement="mainFooter" lotteryKey="qcc" />
    </>
  );
}
export default Qoochan;
